import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Box, Button, Stack, TextField, Typography } from '@mui/material';

import axiosInstance from '../../axiosInstance';
import EcranAuth from '../Auth/EcranAuth';

/**
 * Demander un lien de réinitialisation.
 *
 * La réponse est la même que l'adresse existe ou non : dire « aucun compte
 * avec cet email » permettrait à n'importe qui de tester une liste d'adresses
 * et d'apprendre lesquelles sont clientes.
 */
function PasswordReset() {
  const [email, setEmail] = useState('');
  const [envoye, setEnvoye] = useState(false);
  const [erreur, setErreur] = useState('');
  const [occupe, setOccupe] = useState(false);

  const soumettre = async (e) => {
    e.preventDefault();
    setOccupe(true);
    setErreur('');
    try {
      await axiosInstance.post('password_reset/', { email: email.trim() });
      setEnvoye(true);
    } catch {
      setErreur("L'envoi n'a pas abouti. Réessayez dans un instant.");
    } finally {
      setOccupe(false);
    }
  };

  if (envoye) {
    return (
      <EcranAuth titre="Vérifiez vos emails">
        <Stack spacing={3}>
          <Alert severity="success">
            Si un compte existe pour <strong>{email}</strong>, un lien de
            réinitialisation vient de lui être envoyé.
          </Alert>
          <Typography variant="body2" color="text.secondary">
            Le lien est valable 24 heures et ne sert qu'une fois. S'il
            n'arrive pas, regardez dans vos indésirables.
          </Typography>
          <Button component={Link} to="/login" variant="outlined">
            Retour à la connexion
          </Button>
        </Stack>
      </EcranAuth>
    );
  }

  return (
    <EcranAuth
      titre="Mot de passe oublié"
      sous_titre="Nous vous envoyons un lien pour en choisir un nouveau"
      bas={(
        <Typography variant="body2" color="text.secondary">
          Vous vous en souvenez ?{' '}
          <Box component={Link} to="/login"
               sx={{ color: 'primary.main', fontWeight: 600 }}>
            Se connecter
          </Box>
        </Typography>
      )}
    >
      <Box component="form" onSubmit={soumettre} noValidate>
        {erreur && <Alert severity="error" sx={{ mb: 3 }}>{erreur}</Alert>}

        <Stack spacing={2.5}>
          <TextField
            label="Adresse email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            autoFocus
            required
          />
          <Button type="submit" variant="contained" size="large"
                  disabled={occupe || !email}>
            {occupe ? 'Envoi…' : 'Envoyer le lien'}
          </Button>
        </Stack>
      </Box>
    </EcranAuth>
  );
}

export default PasswordReset;
